module.exports = __webpack_public_path__ + "static/media/list_icon.c1eb3615.svg";